define("Product.Model.Ext", [
  "Product.Model",
  "SC.Configuration",
  "Utils",
  "underscore",
], function (ItemModel, Configuration, Utils, _) {
  "use strict";

  //These models have been extended to add extra parameter to avoid getting cached data

  _.extend(ItemModel.prototype, {
    getImages: function getImages() {
      var item = this.get("item");

      var altText =
        item.get("custitem_cseg_brand") +
        "® " +
        item.getSku() +
        " " +
        item.get("_name");

      var result = [
        {
          url: item.get("custitemitemimageurl1"),
          altimagetext: altText,
        },
        {
          url: item.get("custitemitemimageurl2"),
          altimagetext: altText,
        },
        {
          url: item.get("custitemitemimageurl3"),
          altimagetext: altText,
        },
        {
          url: item.get("custitemitemimageurl4"),
          altimagetext: altText,
        },
      ];

      result = result.filter(function (imageObj) {
        if (imageObj.url) {
          return imageObj;
        }
        return false;
      });

      // Video handled by ImageGallery.View.Ext (custitem_video_url)

      return result.length
        ? result
        : [
            {
              url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                "img/no_image_available.jpeg",
                Configuration.get("imageNotAvailable")
              ),
              altimagetext: item.get("_name"),
            },
          ];
    },
  });
});
